import {z} from 'zod';

import {BaseVehicleValidationSchema} from './BaseVehicleValidationSchema';

// vehicleClassId now lives on the base schema so the sale and rental variants keep it too. The alias
// stays so service pages and the ServiceVehicle type keep naming the entity they edit.
export const ServiceVehicleValidationSchema = BaseVehicleValidationSchema;

export type ServiceVehicleValidationSchemaType = z.infer<typeof ServiceVehicleValidationSchema>;
